module.exports = __webpack_public_path__ + "static/2560-a10b1b187b7f3d212d0f637149783185.jpg";